import { NgModule } from '@angular/core';

import { ModelosGpsComponent } from './modelos-gps.component';
import {SharedModule} from "../../shared/shared.module";
import {ModeloGpsApiService} from "./shared/modelo-gps-api.service";
import {ModeloGpsNavigationService} from "./shared/modelo-gps-navigation.service";
import {ModeloGpsService} from "./shared/modelo-gps.service";
import {ModeloGpsFormComponent} from "./modelo-gps-form/modelo-gps-form.component";
import {ModeloGpsListComponent} from "./modelo-gps-list/modelo-gps-list.component";
import {ModeloGpsRoutingModule} from "./modelos-gps-routing.module";

@NgModule({
    imports: [
        SharedModule,
        ModeloGpsRoutingModule
    ],
    providers: [
        ModeloGpsApiService,
        ModeloGpsNavigationService,
        ModeloGpsService
    ],
    declarations: [
        ModelosGpsComponent,
        ModeloGpsFormComponent,
        ModeloGpsListComponent
    ],
    exports: [
        ModeloGpsListComponent
    ]
})
export class ModeloGpsModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/rastreamentos/modelos-gps/modelos-gps.module.ts
 **/